import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

export default class extends Controller {
  static targets = ["modal", "form", "submit", "spinner", "overlay", "editor"];

  connect() {
    this.handleKeyboard = this.handleKeyboard.bind(this);
    document.addEventListener("keydown", this.handleKeyboard);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeyboard);
  }

  handleKeyboard(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  open() {
    document.body.classList.add("overflow-hidden");
    this.modalTarget.classList.remove("hidden");
    this.editorTarget?.focus();
  }

  close() {
    document.body.classList.remove("overflow-hidden");
    this.modalTarget.classList.add("hidden");
  }

  async submit(event) {
    event.preventDefault();
    this.setLoading(true);

    try {
      const form = this.formTarget;
      const response = await patch(form.action, {
        body: new FormData(form),
      });

      if (response.ok) {
        this.close();
        // Optionally refresh the card or list
        this.dispatch("cardUpdated");
      } else {
        console.error("Failed to update card");
      }
    } catch (error) {
      console.error("Error updating card:", error);
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.submitTarget.disabled = isLoading;
    this.spinnerTarget.classList.toggle("hidden", !isLoading);
  }

  // Handle file uploads
  handleUpload(event) {
    const files = Array.from(event.target.files);
    files.forEach((file) => {
      // Show preview
      this.createFilePreview(file);
      // Start upload
      this.uploadFile(file);
    });
  }

  createFilePreview(file) {
    // Create and show file preview UI
    const preview = document.createElement("div");
    preview.innerHTML = `
      <div class="flex items-center gap-2 p-2 bg-slate-50 dark:bg-slate-800 rounded">
        <svg class="w-4 h-4 text-slate-400" ...></svg>
        <span class="text-sm text-slate-700 dark:text-slate-300">${file.name}</span>
        <div class="loading-spinner hidden"></div>
      </div>
    `;
    this.element.querySelector(".file-previews").appendChild(preview);
  }

  async uploadFile(file) {
    const upload = new DirectUpload(file, this.uploadUrl);

    try {
      await upload.create((error, blob) => {
        if (error) {
          throw error;
        }
        // Add blob id to hidden field for form submission
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = "card[file_ids][]";
        hiddenField.value = blob.signed_id;
        this.formTarget.appendChild(hiddenField);
      });
    } catch (error) {
      console.error("Upload failed:", error);
    }
  }

  // Checklist methods
  addChecklistItem() {
    const template = document.getElementById("checklist-item-template");
    const clone = template.content.cloneNode(true);
    this.element.querySelector(".checklist-items").appendChild(clone);
  }

  removeChecklistItem(event) {
    event.target.closest(".checklist-item").remove();
  }
}
